/**
 * Mapping of icon names to their Lucide React component and Material UI icon paths.
 */
export const activityTypeIconsMap = {
  transcript: {
    lucide: '/dh-icons/transcript.svg',
    material: '/dh-icons/transcript.svg',
    material2: '/dh-icons/transcript.svg',
  },
  note: {
    lucide: '/dh-icons/transcript.svg',
    material: '/dh-icons/transcript.svg',
    material2: '/dh-icons/transcript.svg',
  },
  'email-internal': {
    lucide: '/dh-icons/email.svg',
    material: '/dh-icons/email.svg',
    material2: '/dh-icons/email.svg',
  },
  'email-inbound': {
    lucide: '/dh-icons/email-reply.svg',
    material: '/dh-icons/email-reply.svg',
    material2: '/dh-icons/email-reply.svg',
  },
  'email-inbound-internal': {
    lucide: '/dh-icons/email-reply.svg',
    material: '/dh-icons/email-reply.svg',
    material2: '/dh-icons/email-reply.svg',
  },
  'email-outbound': {
    lucide: '/dh-icons/email-forward.svg',
    material: '/dh-icons/email-forward.svg',
    material2: '/dh-icons/email-forward.svg',
  },
  'email-outbound-internal': {
    lucide: '/dh-icons/email-forward.svg',
    material: '/dh-icons/email-forward.svg',
    material2: '/dh-icons/email-forward.svg',
  },
  call: {
    lucide: '/dh-icons/call.svg',
    material: '/dh-icons/call.svg',
    material2: '/dh-icons/call.svg',
  },
  'call-internal': {
    lucide: '/dh-icons/inbound.svg',
    material: '/dh-icons/inbound.svg',
    material2: '/dh-icons/inbound.svg',
  },
  'call-inbound': {
    lucide: '/dh-icons/inbound.svg',
    material: '/dh-icons/inbound.svg',
    material2: '/dh-icons/inbound.svg',
  },
  'call-inbound-internal': {
    lucide: '/dh-icons/inbound.svg',
    material: '/dh-icons/inbound.svg',
    material2: '/dh-icons/inbound.svg',
  },
  'call-outbound': {
    lucide: '/dh-icons/outbound.svg',
    material: '/dh-icons/outbound.svg',
    material2: '/dh-icons/outbound.svg',
  },
  'call-outbound-internal': {
    lucide: '/dh-icons/outbound.svg',
    material: '/dh-icons/outbound.svg',
    material2: '/dh-icons/outbound.svg',
  },
  meeting: {
    lucide: '/dh-icons/meet.svg',
    material: '/dh-icons/meet.svg',
    material2: '/dh-icons/meet.svg',
  },
  'meeting-internal': {
    lucide: '/dh-icons/meet.svg',
    material: '/dh-icons/meet.svg',
    material2: '/dh-icons/meet.svg',
  },
};
